import React from "react";

const PageHeaderEditor = ({ data, update }) => (
    <div className="cms-editor">

        <label>Eyebrow</label>
        <input
            value={data.eyebrow || ""}
            onChange={e =>
                update("eyebrow", e.target.value)
            }
        />

        <label>Title</label>
        <input
            value={data.title || ""}
            onChange={e =>
                update("title", e.target.value)
            }
        />

        <label>Description</label>
        <textarea
            value={data.description || ""}
            onChange={e =>
                update("description", e.target.value)
            }
        />

    </div>
);

export default PageHeaderEditor;